"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _util = _interopRequireDefault(require("./util"));
var _colors = _interopRequireDefault(require("./colors"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var sizeAdapter = _util["default"].sizeAdapter;
var cursor = function cursor() {
  return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
};
var textOverflow = function textOverflow() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ellipsis';
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-overflow: ", ";\n"])), type);
};
var whiteSpace = function whiteSpace() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nowrap';
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  white-space: ", ";\n"])), type);
};
var getPoints = function getPoints(args) {
  var top;
  var bottom;
  var right;
  var left;
  if (args.length === 1) {
    var _args = _slicedToArray(args, 1),
      all = _args[0];
    top = all;
    bottom = all;
    right = all;
    left = all;
  }
  if (args.length === 2) {
    var _args2 = _slicedToArray(args, 2),
      vertical = _args2[0],
      horizontal = _args2[1];
    top = vertical;
    right = horizontal;
    bottom = vertical;
    left = horizontal;
  }
  if (args.length === 4) {
    var _args3 = _slicedToArray(args, 4);
    top = _args3[0];
    right = _args3[1];
    bottom = _args3[2];
    left = _args3[3];
  }
  return {
    top: sizeAdapter(top),
    right: sizeAdapter(right),
    bottom: sizeAdapter(bottom),
    left: sizeAdapter(left)
  };
};
var splitArgs = function splitArgs(args) {
  var _ref = args.find(function (ele) {
      return _typeof(ele) === 'object';
    }) || {},
    _ref$important = _ref.important,
    important = _ref$important === void 0 ? false : _ref$important;
  return _objectSpread({
    important: important ? ' !important' : ''
  }, getPoints(args.filter(function (ele) {
    return _typeof(ele) !== 'object';
  })));
};
var margin = function margin() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _splitArgs = splitArgs(args),
    top = _splitArgs.top,
    right = _splitArgs.right,
    bottom = _splitArgs.bottom,
    left = _splitArgs.left,
    important = _splitArgs.important;
  return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-top: ", "", ";\n    margin-right: ", "", ";\n    margin-bottom: ", "", ";\n    margin-left: ", "", ";\n  "])), top, important, right, important, bottom, important, left, important);
};
var padding = function padding() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var _splitArgs2 = splitArgs(args),
    top = _splitArgs2.top,
    right = _splitArgs2.right,
    bottom = _splitArgs2.bottom,
    left = _splitArgs2.left,
    important = _splitArgs2.important;
  return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding-top: ", "", ";\n    padding-right: ", "", ";\n    padding-bottom: ", "", ";\n    padding-left: ", "", ";\n  "])), top, important, right, important, bottom, important, left, important);
};
var border = function border() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 1 : _ref2$width,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? 'solid' : _ref2$style,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? _colors["default"].grayLighter : _ref2$color,
    direction = _ref2.direction;
  var _direction = direction ? "-".concat(direction, "-") : '-';
  return (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    border-style: ", ";\n    border", "width: ", ";\n    border", "color: ", ";\n  "])), style, _direction, sizeAdapter(width), _direction, color);
};
var borderRadius = function borderRadius() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var _splitArgs3 = splitArgs(args),
    topLeft = _splitArgs3.top,
    topRight = _splitArgs3.right,
    bottomRight = _splitArgs3.bottom,
    bottomLeft = _splitArgs3.left,
    important = _splitArgs3.important;
  return (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    border-top-left-radius: ", "", ";\n    border-top-right-radius: ", "", ";\n    border-bottom-right-radius: ", "", ";\n    border-bottom-left-radius: ", "", ";\n  "])), topLeft, important, topRight, important, bottomRight, important, bottomLeft, important);
};
var style = {
  cursor: cursor,
  margin: margin,
  padding: padding,
  border: border,
  borderRadius: borderRadius,
  textOverflow: textOverflow,
  whiteSpace: whiteSpace
};
var _default = exports["default"] = style;